import { Box, Typography, Stack, useTheme } from "@mui/material"
import { ReactElement } from "react"

interface IMfaHelpCardProps {
    title: string
    helpTxt: string
    imgSrc: string
    altText: string
}

const MfaHelpCard = ({
    title,
    helpTxt,
    imgSrc,
    altText,
}: IMfaHelpCardProps): ReactElement => {
    const amplifyTheme = useTheme()
    return (
        <Stack
            spacing={1}
            sx={{
                border: `1px solid ${amplifyTheme.palette.divider}`,
                borderRadius: 2,
                p: 2,
                height: "100%",
            }}
        >
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body1" fontWeight={300}>
                {helpTxt}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Box
                component="img"
                src={imgSrc}
                alt={altText}
                sx={{
                    width: "100%",
                    height: "auto",
                    alignSelf: "center",
                    borderRadius: 1,
                    mt: "auto",
                }}
            />
        </Stack>
    )
}

export default MfaHelpCard
